module.exports = __webpack_public_path__ + "static/graph-curve_fr-56634d8947a70fa69c29ad015d7e636d.svg";